import { LocateFixed } from "lucide-react";
import { cn } from "@/lib/utils";

const TXT = {
  on: ["Compartilhando sua localização com o cliente. Mantenha esta página aberta até entregar.", "border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-300"],
  waiting: ["Procurando o sinal do GPS… permita a localização se o celular pedir.", "border-amber-500/40 bg-amber-500/10 text-amber-700 dark:text-amber-300"],
  denied: ["A localização está bloqueada. Ative o GPS e permita a localização para este site, para o cliente acompanhar a entrega.", "border-red-500/40 bg-red-500/10 text-red-700 dark:text-red-300"],
  unsupported: ["Este celular não permite compartilhar a localização pelo navegador.", "border-red-500/40 bg-red-500/10 text-red-700 dark:text-red-300"],
};

export function GpsBanner({ st }) {
  const v = TXT[st];
  if (!v) return null;
  return (
    <p className={cn("flex items-start gap-2 rounded-lg border p-3 text-xs font-medium", v[1])} data-testid="courier-gps-status" data-state={st}>
      <LocateFixed className={cn("mt-0.5 h-4 w-4 shrink-0", st === "on" && "animate-pulse")} />{v[0]}
    </p>
  );
}
